import {parseISO, format} from "date-fns";
import {ChatMessage} from "src/types/generated";

export function createApolloConversationMessage(message: ChatMessage) {
    let date: Date;

    if (typeof message.created === "string") {
        date = parseISO(message.created);
    } else if (message.created instanceof Date) {
        date = message.created;
    } else {
        throw new Error("Invalid created field in ChatMessage");
    }

    const created = format(date, "yyyy-MM-dd'T'HH:mm:ss.SSS");

    return {
        __typename: "ChatMessage",
        id: message.id,
        created,
        text: message.text,
        sender: {
            __typename: "UserField",
            id: message.sender?.id ?? "",
        },
        deleted: message.deleted ?? false,
        isSenderBlocked: message.isSenderBlocked ?? false,
        richContent: message.richContent ?? null,
    };
}
